import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { PaymentMethod } from '../../../services/dto/payment-method';
import { PaymentMethodComponent } from '../../payment-method/payment-method.component';

@Component({
  host: { 'data-cid': 'grid-payment-method-cell' },
  imports: [PaymentMethodComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-payment-method [status]="this.status"></cam-payment-method>
  </div>`,
})
export class GridPaymentMethodCellComponent extends AbstractCellComponent<any, PaymentMethod> {
  get status() {
    return this.value ?? PaymentMethod.Unknown;
  }
}
